import React from 'react';
import './SliderPaginationListItem.scss';

export const SliderPaginationListItem = ({ index, currentSlide, goToSlide }) => {
  const slideNumber = index + 1;

  return(
    <div
      role='button'
      tabIndex={0}
      className={`pagination-list-item ${(slideNumber === currentSlide) ? 'pagination-list-item--active' : ''}`}
      onClick={() => goToSlide(index)}
      onKeyDown={() => goToSlide(index)}
    >
      <span>{`0 ${slideNumber}`}</span>
    </div>
  );
}